import { axios, handleError } from '../axios';

export const addPost = (formData) => {
  return new Promise((resolve, reject) => {
    axios
      .post('admin/post/add', formData)
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
          reject();
        }
      })
      .catch((e) => {
        handleError(e);
        reject();
      });
  });
};
